import UrbanPlayground from '../Images/Icons/UrbanPlaygroundIcon.png';
import LogOut from '../Images/Icons/Logout.png';
import Back from '../Images/Icons/Back.png';
import NewArea from '../Images/Icons/NewArea.png';
import Settings from '../Images/Icons/Settings.png';
import DeleteRed from '../Images/Icons/Delete_Red.png';
import Refresh from '../Images/Icons/Refresh.png';

/**
 * The Application Icons.
 */
const Icons = {
  UrbanPlayground,
  Back,
  LogOut,
  NewArea,
  Settings,
  DeleteRed,
  Refresh,
};

export default Icons;
